import { render } from "./AfterWork.vue?vue&type=template&id=08dd1e90"
import script from "./AfterWork.vue?vue&type=script&lang=js"
export * from "./AfterWork.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__